import React, { useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Stack, Typography } from '@mui/material';

import useSelfScheduleOptionsDelete from './useSelfScheduleOptionsDelete';

type SelfScheduleOpenAlertProps = {
  selfScheduleOptionsId: string;
  onDelete: () => void;
  onClose: () => void;
};

const SelfScheduledApplicationStageAlert = ({
  selfScheduleOptionsId,
  onDelete,
  onClose,
}: SelfScheduleOpenAlertProps) => {
  const { t } = useTranslation();
  const [deleting, setDeleting] = useState(false);

  const { mutation: selfScheduleDelete } = useSelfScheduleOptionsDelete();

  const handleDelete = async () => {
    setDeleting(true);
    await selfScheduleDelete(selfScheduleOptionsId) // eslint-disable-next-line promise/always-return
      .then(() => {
        onDelete();
      })
      .finally(() => {
        setDeleting(false);
      });
  };

  return (
    <Dialog
      open
      onClose={onClose}
      title={t('hiring-dashboard-schedule:schedule.dialog.cancelRequestTitle')}
      submitOptions={{
        label: t('hiring-dashboard-schedule:schedule.selfSchedule.cancelRequest'),
        isDisabled: deleting,
        isLoading: deleting,
        onClick: handleDelete,
        isDangerous: true,
      }}
      cancelOptions={{
        label: t('hiring-dashboard-common:common.dialog.dontCancel'),
        onClick: onClose,
      }}
    >
      <Stack spacing={1}>
        <Typography fontWeight={400}>
          {t('hiring-dashboard-schedule:schedule.selfSchedule.cancelRequestWarning')}
        </Typography>
      </Stack>
    </Dialog>
  );
};

export default SelfScheduledApplicationStageAlert;
